const setPcFixedStyle = (el: HTMLElement, binding: any) => {
  const val = binding.value || {}
  const left = Number(val.left) || 0
  const right = Number(val.right) || 0
  el.style.left = left + 'px'
  el.style.right = right + 'px'
}

export default {
  beforeMount: setPcFixedStyle,
  updated: setPcFixedStyle,
}
